<!-- Solution Section -->
<section class="py-20 bg-white dark:bg-slate-800" id="fonctionnalites">
  <div class="max-w-7xl mx-auto px-4">
    <div class="text-center mb-16 scroll-fade-in">
      <h2 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
        La solution ? <span class="gradient-text">Predivent</span>
      </h2>
      <p class="text-xl text-gray-600 dark:text-gray-400">Simple, explicable, personnalisé</p>
    </div>

    <div class="grid md:grid-cols-2 gap-12 items-center mb-20">
      <div class="scroll-fade-in">
        <div class="inline-block feature-icon text-white rounded-xl p-3 mb-4">
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <h3 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Recommandations en 5 minutes
        </h3>
        <p class="text-lg text-gray-600 dark:text-gray-400 mb-6">
          Tu crées ton événement, on te dit
          <strong>exactement combien préparer</strong> de chaque produit. Basé
          sur ton historique, la météo, le type d'événement et la durée.
        </p>
        <ul class="space-y-3">
          <li class="flex items-start gap-3">
            <svg
              class="w-6 h-6 text-green-500 flex-shrink-0 mt-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Prend en compte la météo en temps réel</span
            >
          </li>
          <li class="flex items-start gap-3">
            <svg
              class="w-6 h-6 text-green-500 flex-shrink-0 mt-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Apprend de ton historique personnel</span
            >
          </li>
          <li class="flex items-start gap-3">
            <svg
              class="w-6 h-6 text-green-500 flex-shrink-0 mt-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300">Explique chaque recommandation</span>
          </li>
        </ul>
      </div>

      <div
        class="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 scroll-fade-in"
      >
        <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-lg dark:shadow-slate-900/50">
          <div class="flex items-center gap-3 mb-4">
            <div
              class="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl"
            >
              1
            </div>
            <div>
              <div class="font-bold text-gray-900 dark:text-white">Crée ton événement</div>
              <div class="text-sm text-gray-600 dark:text-gray-400">
                Date, lieu, type, horaires
              </div>
            </div>
          </div>
          <div class="flex items-center gap-3 mb-4">
            <div
              class="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl"
            >
              2
            </div>
            <div>
              <div class="font-bold text-gray-900 dark:text-white">On calcule pour toi</div>
              <div class="text-sm text-gray-600 dark:text-gray-400">Météo + historique + IA</div>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl"
            >
              3
            </div>
            <div>
              <div class="font-bold text-gray-900 dark:text-white">Exporte ta liste</div>
              <div class="text-sm text-gray-600 dark:text-gray-400">
                Imprime ou consulte sur mobile
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- More Features -->
    <div class="grid md:grid-cols-3 gap-8 mt-16">
      <div class="text-center p-8 scroll-fade-in">
        <div class="inline-block feature-icon text-white rounded-full p-4 mb-4">
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        </div>
        <h4 class="text-xl font-bold text-gray-900 dark:text-white mb-2">Feedback immédiat</h4>
        <p class="text-gray-600 dark:text-gray-400">
          Après chaque événement, saisis tes ventes et vois ta précision. L'algo
          s'améliore à chaque fois.
        </p>
      </div>

      <div class="text-center p-8 scroll-fade-in">
        <div class="inline-block feature-icon text-white rounded-full p-4 mb-4">
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h4 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Gain de temps massif
        </h4>
        <p class="text-gray-600 dark:text-gray-400">
          Fini les 2-3h par semaine à "deviner". Tu obtiens une reco en 2
          minutes chrono.
        </p>
      </div>

      <div class="text-center p-8 scroll-fade-in">
        <div class="inline-block feature-icon text-white rounded-full p-4 mb-4">
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h4 class="text-xl font-bold text-gray-900 dark:text-white mb-2">Mobile-first</h4>
        <p class="text-gray-600 dark:text-gray-400">
          Conçu pour être utilisé sur ton smartphone, n'importe où, même sans
          réseau (PWA).
        </p>
      </div>
    </div>
  </div>
</section>